import { useEffect, useState } from 'react'
import { Text } from '../../../components'
import { Promotion, formatPromotionDate, promotionToday } from '../../../helpers/promotions'
import { CrmRequest, PAGE_SIZE, ensureOk, getErrorMessage } from '../api'
import { ListStatus, Pager } from '../components'

interface CrmPromotion extends Promotion {
    store_title: string | null;
    client_login: string | null;
}

export const PromotionsTab = ({request}: {request: CrmRequest}) => {
    const [offset, setOffset] = useState(0)
    const [items, setItems] = useState<CrmPromotion[]>([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [revision, setRevision] = useState(0)
    useEffect(() => {
        const controller = new AbortController()
        setLoading(true); setError(null)
        const load = async () => {
            try {
                const res = await request(`/crm/get-promotions?offset=${offset}&limit=${PAGE_SIZE}`, {signal: controller.signal})
                if (!res) return
                await ensureOk(res, 'Не удалось загрузить акции')
                const data = await res.json()
                if (controller.signal.aborted) return
                if (offset > 0 && offset >= data.total) {
                    setOffset(Math.max(0, Math.ceil(data.total / PAGE_SIZE) - 1) * PAGE_SIZE)
                    return
                }
                setItems(data.promotions); setTotal(data.total)
            } catch (err) {
                if (!controller.signal.aborted) setError(getErrorMessage(err, 'Не удалось загрузить акции'))
            } finally { if (!controller.signal.aborted) setLoading(false) }
        }
        load()
        return () => controller.abort()
    }, [request, offset, revision])
    return <div className="crm-list">
        <Text size="s" color="lightGray">{`Все акции: ${total}. Включая действующие, будущие и завершённые.`}</Text>
        <ListStatus loading={loading} error={error} empty={items.length === 0} emptyText="Акций нет" />
        {error && <button type="button" className="admin-edit-btn" onClick={() => setRevision(value => value + 1)}>Повторить</button>}
        {!loading && !error && items.map(item => <article className="crm-promotion-card" key={item.id}>
            <div className="crm-code-meta">
                <span className="admin-template-badge">{item.blogOnly ? 'Для блогеров' : 'Для всех'}</span>
                <span className="admin-link-metric">{item.endDate <= promotionToday() ? 'Завершена' : item.startDate > promotionToday() ? 'Запланирована' : 'Действует'}</span>
            </div>
            <Text size="m" color="white">{item.name}</Text>
            <p className="crm-promotion-description">{item.description || 'Без описания'}</p>
            <span className="admin-link-metric">{`${formatPromotionDate(item.startDate)} — ${formatPromotionDate(item.endDate)}`}</span>
            <a href={`/${item.store_id}`} target="_blank" rel="noreferrer">{item.store_title || `Страница #${item.store_id}`}</a>
            <span className="admin-link-metric">{`Акция #${item.id} · Страница #${item.store_id} · ${item.client_login || 'Клиент не найден'}`}</span>
        </article>)}
        <Pager offset={offset} hasNext={!error && offset + PAGE_SIZE < total} loading={loading} onChange={setOffset} />
    </div>
}
